import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../productsAction';
import fetchApi from "./fetchApi";

function fetchProductsAction() {
  var milliseconds = new Date().getTime();
  return fetchApi('/v1/fc_api/products_resource?c=' + milliseconds, fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchProductsAction;
